'use client';
import { useState } from 'react';
import FormErrorTips from '../FormErrorTips';

export default function FormInput({ id, data, callback, name }: any) {
    const [showError, setShowError] = useState(false);
    const changeHandle = (e: any) => {
        const val = e.target.value;
        callback && callback(data, val, name);
        if (data.isRequire && !val) {
            setShowError(true);
        } else {
            setShowError(false);
        }
    };
    return (
        <div className={`form-common-content form-common-content-${data.formWidth} ${showError ? ' form-common-show-error' : ''}`}>
            <input className="form-common-input" placeholder={data.placeholder} value={data.itemVal} onChange={changeHandle} maxLength={data.maxLen || 200} />
            {data.isRequire && <FormErrorTips data={data} />}
        </div>
    );
}
